module.exports = __webpack_public_path__ + "img/27.a783569b.svg";